const auth = state => state.account !== null
const saved = state => state.saved
const account = state => state.account

export default {
  auth,
  saved,
  account
}
